import { memo } from 'react'
import PointComponent from 'component/Survey/Create/Logic/Jump/Point/Component'

function PointContainer() {
    return (
        <PointComponent/>
    )
}

export default memo(PointContainer)